
module.exports = {
    isPermission,
    getPermission
}

function isPermission(admin, token) {

    if(!admin.permissions || !admin.permissions.length)
        return true

    return admin.permissions.indexOf(token) >= 0
}

function getPermission(value) {
    switch(value) {
        case 'GraphicsView': return 'Vista Graficas'
        case 'InvoicesView': return 'Vista Facturas'
        case 'InvoicesView.Invoices': return 'Vista Facturas'
        case 'InvoicesView.Reports': return 'Vista Facturas'
        case 'InvoicesView.Impuestos': return 'Vista Facturas'
        case 'InvoicesView.Nominas': return 'Vista Facturas'
        case 'InvoicesView.Declaraciones': return 'Vista Facturas'
        case 'InvoicesView.Compras': return 'Vista Facturas'
        case 'InvoicesView.Match': return 'Vista Facturas'
        case 'ShipmentsView': return 'Vista Envios'
        case 'ShipmentsView.Shipment.Sync': return 'Envio, Sincronizar envío'
        case 'ShipmentsView.Shipment.Report': return 'Envio, Descargar reporte'
        case 'ShipmentsView.Shipment.ReportTracing': return 'Envio, Subir seguimiento'
        case 'ShipmentsView.Shipment.Cancel': return 'Envio, Cancelar envío'
        case 'ShipmentsView.Shipment.Charges': return 'Envio, Agregar cargos'
        case 'ShipmentsView.Shipment.Tracing': return 'Envio, Agregar seguimiento'
        case 'ShipmentsView.Shipment.Incidents': return 'Envio, Agregar incidencia'
        case 'ShipmentsView.Shipment.Status': return 'Envio, Actualizar estatus'
        case 'UsersView': return 'Vista Usuarios'
        case 'UsersView.User.View': return 'Usuario, Ver datos de usuario'
        case 'UsersView.User.Graphics': return 'Usuario, Ver graficas de usuario'
        case 'UsersView.User.Quice': return 'Usuario, Descargar encuesta'
        case 'UsersView.User.Global': return 'Usuario, Agregar notificación global'
        case 'UsersView.User.Admin': return 'Usuario, Agregar notificación admin'
        case 'UsersView.User.Invitation': return 'Usuario, Agregar invitación'
        case 'UsersView.User.Update': return 'Usuario, Actualizar datos'
        case 'UsersView.Wallet.View': return 'Cartera, Ver saldo'
        case 'UsersView.Wallet.Create': return 'Cartera, Agregar saldo'
        case 'UsersView.Credits.View': return 'Créditos, Ver Créditos'
        case 'UsersView.Credit.Update': return 'Crédito, Actualizar Crédito'
        case 'UsersView.Credit.Delete': return 'Crédito, Borrar Crédito'
        case 'TracingsView.Credit.Report': return 'Seguimiento, Descargar reporte de crédito'
        case 'UsersView.Charges.View': return 'Cargos, Ver Cargos'
        case 'UsersView.Charge.Create': return 'Cargo, Agregar cargo'
        case 'TracingsView.Charge.Download': return 'Seguimiento, Descargar cargos'
        case 'TracingsView.Charge.Upload': return 'Seguimiento, Subir cargos'
        case 'UsersView.Pricing.View': return 'Pricing, Ver Pricing'
        case 'UsersView.Prices.View': return 'Precios, Ver Precios'
        case 'UsersView.Price.Create': return 'Precio, Agregar precio'
        case 'UsersView.Price.Update': return 'Precio, Actualizar precio'
        case 'UsersView.Price.Delete': return 'Precio, Eliminar precio'
        case 'UsersView.Prepaids.View': return 'Prepagos, Ver Prepagos'
        case 'UsersView.Prepaid.Create': return 'Prepago, Agregar prepago'
        case 'UsersView.Prepaid.Update': return 'Prepago, Actualizar prepago'
        case 'UsersView.Prepaid.Delete': return 'Prepago, Eliminar prepago'
        case 'UsersView.Fixedprices.View': return 'Precios fijos, Ver Precios fijos'
        case 'UsersView.Fixedprice.Create': return 'Precio fijo, Agregar precio fijo'
        case 'UsersView.Fixedprice.Delete': return 'Precio fijo, Eliminar precio fijo'
        case 'UsersView.Accounts.View': return 'Cuentas, Ver Cuentas'
        case 'UsersView.Account.Create': return 'Cuenta, Agregar cuenta'
        case 'UsersView.Account.Update': return 'Cuenta, Actualizar cuenta'
        case 'UsersView.Account.Delete': return 'Cuenta, Eliminar cuenta'
        case 'UsersView.Account.ReportCharges': return 'Cuenta, Descargar reporte de cargos'
        case 'UsersView.Account.ReportShipments': return 'Cuenta, Descargar reporte de envios'
        case 'UsersView.Modules.View': return 'Modulos, Ver modulos'
        case 'UsersView.Module.Create': return 'Modulos, Agregar membresia'
        case 'UsersView.Module.Update': return 'Modulos, Actualizar membresia modulo'
        case 'UsersView.Notifications.View': return 'Notificaciones, Ver notificaciones'
        case 'UsersView.Notification.Create': return 'Notificaciones, Agregar notificacion'
        case 'UsersView.Notification.Update': return 'Notificacion, Actualizar notificacion'
        case 'UsersView.Notification.Delete': return 'Notificacion, Eliminar notificacion'
        case 'UsersView.Billings.View': return 'Razón social, Ver Razón social'
        case 'UsersView.Billing.Create': return 'Razón social, Agregar Razón social'
        case 'UsersView.Billing.Update': return 'Razón social, Actualizar Razón social'
        case 'UsersView.Billing.Delete': return 'Razón social, Eliminar Razón social'
        case 'UsersView.Invoices.View': return 'Facturas, Ver Facturas'
        case 'UsersView.Invoice.Create': return 'Factura, Agregar Factura ordinaria'
        case 'UsersView.Invoice.CreateFree': return 'Factura, Agregar Factura extra'
        case 'UsersView.Providers.View': return 'Proveedores, Ver Proveedores'
        case 'UsersView.Provider.Create': return 'Proveedor, Agregar Proveedor'
        case 'UsersView.Provider.Delete': return 'Proveedor, Eliminar Proveedor'
        case 'UsersView.Zipcodes.View': return 'Estafeta C.P, Ver códigos postales'
        case 'UsersView.Zipcode.Create': return 'Estafeta C.P, Agregar código postal'
        case 'TracingsView': return 'Vista Seguimiento'
        case 'TracingsView.Pickups.View': return 'Recolecciones, Ver Recolecciones'
        case 'TracingsView.Pickups.Update': return 'Recolección, Actualizar Recolección'
        case 'TracingsView.Tickets.View': return 'Tickets, Ver Tickets'
        case 'TracingsView.Ticket.Update': return 'Tickets, Actualizar Tickets'
        case 'TracingsView.Shopify.View': return 'Shopify, Ver Shopify'
        case 'TracingsView.Shopify.Update': return 'Shopify, Actualizar Shopify'
        case 'SettingsView': return 'Vista Configuración'
        case 'SettingsView.Pricings.View': return 'Pricing, Ver Pricing'
        case 'SettingsView.Pricing.Upload': return 'Pricing, Subir Pricing'
        case 'SettingsView.Pricing.Update': return 'Pricing, Actualizar Pricing'
        case 'SettingsView.Pricing.Delete': return 'Pricing, Borrar Pricing'
        case 'SettingsView.Notices.View': return 'Avisos, Ver Avisos'
        case 'SettingsView.Notice.Create': return 'Aviso, Agregar Aviso'
        case 'SettingsView.Notice.Update': return 'Aviso, Actualizar Aviso'
        case 'SettingsView.Notice.Delete': return 'Aviso, Borrar Aviso'
        case 'SettingsView.Tips.View': return 'Tips, Ver Tips'
        case 'SettingsView.Tip.Create': return 'Tip, Agregar Tip'
        case 'SettingsView.Tip.Update': return 'Tip, Actualizar Tip'
        case 'SettingsView.Tip.Delete': return 'Tip, Borrar Tip'
        case 'SettingsView.Tutorials.View': return 'Tutoriales, Ver Tutoriales'
        case 'SettingsView.Tutorial.Create': return 'Tutorial, Agregar Tutorial'
        case 'SettingsView.Tutorial.Update': return 'Tutorial, Actualizar Tutorial'
        case 'SettingsView.Tutorial.Delete': return 'Tutorial, Borrar Tutorial'
        case 'SettingsView.Courses.View': return 'Cursos, Ver Cursos'
        case 'SettingsView.Course.Create': return 'Curso, Agregar Curso'
        case 'SettingsView.Course.Update': return 'Curso, Actualizar Curso'
        case 'SettingsView.Course.Delete': return 'Curso, Borrar Curso'
        case 'SettingsView.Providers.View': return 'Proveedores, Ver Proveedores'
        case 'SettingsView.Provider.Create': return 'Proveedor, Agregar Proveedor'
        case 'SettingsView.Provider.Update': return 'Proveedor, Actualizar Proveedor'
        case 'SettingsView.Provider.Delete': return 'Proveedor, Borrar Proveedor'
        case 'SettingsView.Folios.View': return 'Folios, Ver Folios'
        case 'SettingsView.Folios.Create': return 'Folios, Agregar folios'
        case 'SettingsView.Folios.Delete': return 'Folios, Eliminar folios'
        default: return value
    }
}